/** The income row a rental adds to a retirement plan's "other income". */
export function rentalIncomeRow(label, annualCashFlow, profile) {
  return {
    label,
    kind: 'taxable',
    annual: Math.round(annualCashFlow),
    fromAge: profile.spouse1?.retirementAge ?? 65,
    toAge: profile.lifeExpectancy ?? 90,
  };
}
